export default __webpack_public_path__ + "static/media/c2.4bef9de5.jpeg";